const addLang = {
  Desktop: ['Desktop', '桌面'],
  Mobile: ['Mobile', '移动端'],
  Preview: ['Preview', '预览'],
  Create: ['Create', '创建'],
  Save: ['Save', '保存'],
  Main_Page: ['Main Page', '游戏页面'],
  Tank_You: ['Tank You', '中奖页面'],
  DESIGN: ['DESIGN', '设计'],
  TEXT: ['TEXT', '文案'],
  COUPONS: ['COUPONS', '优惠券'],
  SETTINGS: ['SETTINGS', '设置'],
  IMAGE: ['IMAGE', '主页图片'],
  GAME_POSITION: ['GAME POSITION', '游戏页面所在位置'],
  TRIGGER_POSITION: ['TRIGGER POSITION', '触发器所在位置'],
  CONTACTS_TYPE: ['CONTACTS TYPE', '留咨类型'],
  EMAIL: ['EMAIL', '邮箱'],
  When_customers_are_logged: [
    'When customers are logged into Facebook, only the  Messenger widget shows up. When there is no Facebook login detected, shows the email field.',
    '默认显示Messenger 如果facebook账号未登录则显示邮箱'
  ],
  ENTER_FIRST_NAME: ['ENTER FIRST NAME', '需要输入用户名字'],
  MAKE_GDPR_COMPLIANCE: ['MAKE GDPR COMPLIANCE', '使用GDPR规则'],
  Add_mandatory_checkbox: [
    'Add mandatory checkbox to your game for validation that the visitor agrees to join the mailing list to follow GDPR regulations.',
    '遵守欧盟GDPR规则，收集邮箱必须用户授权确认'
  ],
  MAIN_PAGE_TITLE: ['MAIN PAGE TITLE', '主标题文案'],
  SUBTITLE: ['SUBTITLE', '副标题'],
  BUTTON: ['BUTTON', '按钮文案'],
  THANK_YOU_PAGE_TITLE: ['THANK YOU PAGE TITLE', '中奖页面标题文案'],
  add_SUBTITLE_2: ['SUBTITLE'],
  add_TEXT: ['TEXT', '文案'],
  DESCRIPTION: ['DESCRIPTION', '描述信息'],
  URL: ['URL', '设置按钮链接'],
  RIGGER_TXT: ['RIGGER TXT', '触发器文案'],
  COUPON_TITLE: ['COUPON TITLE', '优惠券名称'],
  COUPON_CODE: ['COUPON CODE', '优惠券编码'],
  Coupon_Sync: ['Coupon Synchronism form shopify', '同步shopfiy优惠券'],
  ENTER_COUPON_TITLE: ['ENTER COUPON TITLE', '输入优惠券名称'],
  GravityAndChance: ['Gravity / Chance', '权重/机会'],
  FOR_HOW_MANY_TIMES: ['FOR HOW MANY TIMES', '频率'],
  Not_more_than_once_every: ['Not more than once every', '每个用户弹框显示'],
  per_user: ['per user', '天'],
  SHOW_ON_A: ['SHOW ON A', '时间'],
  Ongoing: ['Ongoing', '一直进行'],
  Fixed: ['Fixed', '指定时间'],
  ALLOW_USERS_TO_PLAY_WITH_THE_SAME_E_OR_MESSENGER: [
    'ALLOW USERS TO PLAY WITH THE SAME E OR MESSENGER?',
    '是否允许相同订阅重复中奖?'
  ],
  AUTO_EXPORT_TO_SHOPIFY: [
    'AUTO EXPORT TO SHOPIFY',
    '自动同步邮箱到shopify后台'
  ],
  WHEN_TO_SHOW: ['WHEN TO SHOW', '行为触发条件'],
  The_game_will_appear_after: ['The game will appear after', '在页面停留'],
  second: ['second(s)', '秒'],
  day: ['day', '每天'],
  week: ['week', '每周'],
  month: ['month', '每月'],
  TIMES: ['times', '次'],
  WHO_TO_SHOW: ['WHO TO SHOW', '用户触发条件'],
  ALL: ['ALL', '全部用户'],
  PORTION: ['PORTION', '指定用户'],
  ADD_NEW_TRIGGER: ['ADD NEW TRIGGER'],
  Returning: ['Returning', '老用户'],
  New: ['New', '新用户'],
  Cart_value: ['Cart TotalPrice >=', '购物车金额 >='],
  not_allow: ['no', '不允许'],
  POSITION: ['POSITION', '所在位置'],
  SETTINGS_FAILED: ['SETTINGS FAILED', '保存失败'],
  SETTINGS_SUCCESSED: ['SETTINGS SUCCESSED', '保存成功'],
  Are_You_Sure_Start_Game: [
    'Are you sure you want to Activete this game!',
    '你是否立即启动游戏！'
  ],
  Are_You_Sure: [
    'Are you sure you want to navigate away from this page?',
    '您确定要离开该页面吗?'
  ]
};
export default addLang;
